/**
 * Closed NQ minutes and the minute that is still forming.
 *
 * The forming read fails closed: a missing route or a dead subscriber
 * returns null so the candle chart still draws.
 */

import { apiClient } from './api';

export interface NqMinute {
  ts: string;
  open: number;
  high: number;
  low: number;
  close: number;
  volume: number;
}

interface Envelope<T> {
  status: string;
  data: T;
}

export async function getNqBars(start: string, end: string): Promise<NqMinute[]> {
  const response = await apiClient.get<Envelope<{ bars: NqMinute[] }>>(
    '/api/market-data/cme/ohlc/',
    {
      symbol: 'NQ.CME',
      start,
      end,
      fresh: '1',
    },
  );
  const bars = response.data?.bars;
  return Array.isArray(bars) ? bars : [];
}

export async function getNqForming(): Promise<NqMinute | null> {
  try {
    const response = await apiClient.get<Envelope<{ bar: NqMinute | null }>>(
      '/api/market-data/cme/nq-forming/',
    );
    const bar = response.data?.bar;
    if (!bar || typeof bar.ts !== 'string' || typeof bar.close !== 'number') return null;
    return bar;
  } catch {
    return null;
  }
}
